<template>
  <div class="check-list-action auto-list_col_centered">
    <div>
      <el-button
        type="danger"
        icon="el-icon-delete"
        circle
        @click="deleteResponse(response.id)"
      />
    </div>
    <div>
      <el-button
        :disabled="activeActionAccept"
        type="success"
        icon="el-icon-success"
        circle
        @click="acceptResponse(response.id)"
      />
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { errHandler } from '@/helpers/errorHandler'
import { mapMutations } from 'vuex'

const ResponsesInProgress = RepositoryFactory.get('responseRequest')

export default {
  name: 'ActionInProgress',
  props: {
    response: {
      type: Object,
      default: () => ({}),
    },
    activeActionAccept: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    ...mapMutations('loadDay', ['updateResponsesInProgress']),

    deleteResponse(id) {
      this.$confirm('Вы уверены что хотите удалить?', '', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Отмена',
        type: 'warning',
        customClass: this.isMobile ? 'before-del' : '',
      }).then(() => {
        ResponsesInProgress.declineRequest({ id }).then(response => {
          if (response) {
            this.$message({
              type: 'success',
              message: 'Заявка отклонена',
              duration: 4000,
            })
            this.updateResponsesInProgress(response.data)
          } else {
            this.$message({
              type: 'error',
              message: 'Отклонение заявки не произошло. Что то пошло не так!',
              duration: 4000,
            })
          }
        })
      })
    },
    acceptResponse(id) {
      this.$confirm('Вы уверены что хотите подтвердить?', '', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Отмена',
        type: 'warning',
        customClass: this.isMobile ? 'before-del' : '',
      }).then(() => {
        ResponsesInProgress.acceptRequest({ id })
          .then(response => {
            if (response) {
              this.$message({
                type: 'success',
                message: 'Заявка подтверждена',
                duration: 4000,
              })
              this.updateResponsesInProgress(response.data)
              this.$emit('accepted')
            } else {
              this.somethingWrong()
            }
          })
          .catch(err => {
            // костыль. Если из админ-интерфейса создаем отклик на день, в котором уже есть
            // отклик на эту машину, то запрашиваем подтверждение и повторно отправляем ее с force_create
            const isDuplicate = err.response.data.find(
              error => error.field === 'response_exists',
            )

            if (isDuplicate) {
              this.$confirm(
                'На данное авто уже есть запись на погрузку в этот день. Вы уверены?',
                'Внимание!',
                {
                  confirmButtonText: 'Да',
                  cancelButtonText: 'Отмена',
                  type: 'warning',
                  customClass: 'duplicate-response',
                },
              ).then(() => {
                ResponsesInProgress.acceptRequest({ id, force_create: 1 }).then(
                  response => {
                    if (response) {
                      this.$message({
                        type: 'success',
                        message: 'Заявка подтверждена',
                        duration: 4000,
                      })
                      this.updateResponsesInProgress(response.data)
                      this.$emit('accepted')
                    } else {
                      this.somethingWrong()
                    }
                  },
                )
              })
            } else {
              this.$message({
                type: 'error',
                message: `Подтверждение заявки не произошло. ${errHandler(
                  err,
                )}`,
                duration: 4000,
              })
            }
          })
      })
    },
    somethingWrong() {
      this.$message({
        type: 'error',
        message: 'Подтверждение заявки не произошло. Что то пошло не так!',
        duration: 4000,
      })
    },
  },
}
</script>

<style lang="sass" scoped>
.bids-list .middle-section .check-list .auto-list_col .check-list-action
  display: flex
  &>div
    margin: 3px
    &>img
      margin: 0
</style>
